import * as React from "react";
import { forwardRef } from "react";
const SvgClose = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 26, height: 27, viewBox: "0 0 26 27", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M17.5531 8.9502L8.45312 18.0502M17.5531 18.0502L8.45312 8.9502L17.5531 18.0502Z", stroke: "#93949A", strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgClose);
export { ForwardRef as ReactComponent };
